import { render, staticRenderFns } from "./CaisseGeneralTab.vue?vue&type=template&id=5d224290&scoped=true&"
import script from "./CaisseGeneralTab.vue?vue&type=script&lang=js&"
export * from "./CaisseGeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./CaisseGeneralTab.vue?vue&type=style&index=0&id=5d224290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d224290",
  null
  
)

export default component.exports